import React from 'react';

export const SearchIcon: React.FC = () => (
  <svg
    className="profile-training__search-icon-svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.25 14.25C11.5637 14.25 14.25 11.5637 14.25 8.25C14.25 4.93629 11.5637 2.25 8.25 2.25C4.93629 2.25 2.25 4.93629 2.25 8.25C2.25 11.5637 4.93629 14.25 8.25 14.25Z"
      stroke="#7A8699"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.75 15.75L12.4875 12.4875"
      stroke="#7A8699"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ArrowIcon: React.FC = () => (
  <svg
    className="profile-training__chapter-arrow-svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.66663 3.33334L10.3333 8.00001L5.66663 12.6667"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DocumentIcon: React.FC = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.25 2.25H9.5625L12.75 5.4375V13.5C12.75 14.3284 12.0784 15 11.25 15H5.25C4.42157 15 3.75 14.3284 3.75 13.5V3.75C3.75 2.92157 4.42157 2.25 5.25 2.25Z"
      stroke="#4A5568"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.5625 2.25V4.875C9.5625 5.70343 10.2341 6.375 11.0625 6.375H12.75"
      stroke="#4A5568"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 9H10.5"
      stroke="#4A5568"
      strokeWidth="1.25"
      strokeLinecap="round"
    />
    <path
      d="M6 11.25H9"
      stroke="#4A5568"
      strokeWidth="1.25"
      strokeLinecap="round"
    />
  </svg>
);

export const VideoIcon: React.FC = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="2.5"
      y="3.75"
      width="12.5"
      height="12.5"
      rx="3"
      stroke="#1E6F9F"
      strokeWidth="1.5"
    />
    <path
      d="M15 8.75L17.5 7.25V13.75L15 12.25"
      stroke="#1E6F9F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 8.75L11.5 10L9 11.25V8.75Z"
      fill="#1E6F9F"
      stroke="#1E6F9F"
      strokeWidth="1.25"
      strokeLinejoin="round"
    />
  </svg>
);

export const EyeIcon: React.FC = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 3.75C10.6111 3.75 12.9444 5.22222 14.1111 7.5C12.9444 9.77778 10.6111 11.25 8 11.25C5.38889 11.25 3.05556 9.77778 1.88889 7.5C3.05556 5.22222 5.38889 3.75 8 3.75Z"
      stroke="#7A8699"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 9.25C9.10457 9.25 10 8.35457 10 7.25C10 6.14543 9.10457 5.25 8 5.25C6.89543 5.25 6 6.14543 6 7.25C6 8.35457 6.89543 9.25 8 9.25Z"
      stroke="#7A8699"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TimeIcon: React.FC = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 14C11.0376 14 13.5 11.5376 13.5 8.5C13.5 5.46243 11.0376 3 8 3C4.96243 3 2.5 5.46243 2.5 8.5C2.5 11.5376 4.96243 14 8 14Z"
      stroke="#7A8699"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 6V8.5L10 9.5"
      stroke="#7A8699"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LessonsIcon: React.FC = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.75 2.75H9.125L11.75 5.375V12.25C11.75 12.6642 11.4142 13 11 13H4.75C4.33579 13 4 12.6642 4 12.25V3.5C4 3.08579 4.33579 2.75 4.75 2.75Z"
      stroke="#7A8699"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.125 2.75V4.875C9.125 5.28921 9.46079 5.625 9.875 5.625H11.75"
      stroke="#7A8699"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TestsIcon: React.FC = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 4H11C11.5523 4 12 4.44772 12 5V11C12 11.5523 11.5523 12 11 12H5C4.44772 12 4 11.5523 4 11V5C4 4.44772 4.44772 4 5 4Z"
      stroke="#7A8699"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.5 7.25L7.625 8.375L9.5 6.5"
      stroke="#2A5E38"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ProgressIcon: React.FC = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 2.5V4.5"
      stroke="#2A5E38"
      strokeWidth="1.25"
      strokeLinecap="round"
    />
    <path
      d="M8 11.5V13.5"
      stroke="#7A8699"
      strokeWidth="1.25"
      strokeLinecap="round"
    />
    <path
      d="M3.96447 4.96447L5.37868 6.37868"
      stroke="#2A5E38"
      strokeWidth="1.25"
      strokeLinecap="round"
    />
    <path
      d="M10.6213 11.6213L12.0355 13.0355"
      stroke="#7A8699"
      strokeWidth="1.25"
      strokeLinecap="round"
    />
    <path
      d="M2.5 8H4.5"
      stroke="#7A8699"
      strokeWidth="1.25"
      strokeLinecap="round"
    />
    <path
      d="M11.5 8H13.5"
      stroke="#2A5E38"
      strokeWidth="1.25"
      strokeLinecap="round"
    />
    <path
      d="M3.96447 11.0355L5.37868 9.62132"
      stroke="#7A8699"
      strokeWidth="1.25"
      strokeLinecap="round"
    />
    <path
      d="M10.6213 4.37868L12.0355 2.96447"
      stroke="#2A5E38"
      strokeWidth="1.25"
      strokeLinecap="round"
    />
    <circle
      cx="8"
      cy="8"
      r="2.25"
      stroke="#2A5E38"
      strokeWidth="1.25"
    />
  </svg>
);

